export function ConnectedBar({ label = 'Connected' }: { label?: string }) {
    return (
        <div className="w-connected">
            <span className="w-connected-check" aria-hidden>
                ✓
            </span>
            {label}
        </div>
    );
}
